// The English table (ship 3): the same keys, kinds and placeholders as th.js — apps/phone-case/test/tables.test.js
// holds the two together. Phones are named as what the case fits (spec D19): plain text, no brand marks.
const S = {
  title: "Phone case with a name",
  beta: "Beta",
  phone: "Phone model",
  forPhone: (name) => `Case for ${name}`,
  material: "Material",
  materials: {
    flex: "Flexible (TPU)",
    rigid: "Rigid (PETG)",
  },
  thick: "Thickness",
  thicks: {
    slim: "Slim",
    standard: "Standard",
    tough: "Tough",
  },
  fit: "Fit",
  fits: {
    tight: "Tight",
    normal: "Just right",
  },
  src: "Back art",
  textHint: (lines, chars) => `Up to ${lines} lines, at most ${chars} characters each`,
  loadingFont: (family, got, total) => (total > 0 ? `Loading ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `Loading ${family} ${got.toFixed(1)} MB`),
  finish: "Art style",
  finishes: {
    flush: "Flush, 2 colours",
  },
  turn: "Orientation",
  turns: {
    "0": "Horizontal",
    "90": "Vertical",
  },
  scale: "Size",
  pos: "Position",
  position: (v) => (Math.abs(v) < 0.005 ? 'Centre' : `${v > 0 ? 'Up' : 'Down'} ${Math.round(Math.abs(v) * 100)}%`),   // R71: the narrowest of the three pairs measured (see main.css)
  needFile: "Choose the SVG file — it stays on your device and is sent nowhere",
  artKept: "The art lives only in this tab — after a refresh you must choose the file again",
  keptOld: "(still using the previous art)",
  thumb: "Preview of the art read",
  shareNoArt: "This link carries no SVG file — whoever opens it must choose the file themselves",
  linkNeedsArt: "This design uses art from a file, which the link does not carry — choose an SVG file to add it",
  gColour: "Colours",
  colourCase: "Case colour",
  colourArt: "Art colour",
  notes: {
    untested: (name, material) => `Not yet print-tested for ${name} in ${material}`,
    settings: "Print back-down on the plate, no supports, 0.2 mm layer height",
    tested: (name, material) => `Print-tested for ${name} in ${material}`,
    proud: (mm) => `The camera lenses stand ${mm} mm past the back — the phone rocks when laid face-up on a table`,
    flush: "Flush 2-colour art needs a multi-colour printer and the 3MF file (the STL has no art, so it is closed)",
    engraved: "Engraved art is one colour, no filament change — STL or 3MF both work",
    pla: "PLA is not recommended — it cracks when snapped on and softens when the phone runs warm; use TPU or PETG",
    terms: "For learning and personal use — you use it at your own risk",
  },
  size: (x, y, z) => `Case size ${x.toFixed(1)} × ${y.toFixed(1)} × ${z.toFixed(1)} mm`,
  grams: (g) => `Weighs about ${Math.round(g)} g`,
  views: {
    back: "Back",
    front: "Front",
    side: "Side",
  },
  problem: {
    "no-art": "No text to print — you get a plain case",
    "thin-text": "The letters are very thin — some strokes may not print; try a larger size or fewer characters",
    "same-colour": "The art colour matches the case colour — the art will be invisible",
    "thin-parts": "The art has thin strokes attached to thick parts — a slicer may cut them away",
    dropped: (p) => `Dropped ${p.n} pieces too thin to print from the art`,
    "all-thin": "The art is too thin for this size — no download",
    "art-too-complex": "The art is too complex — no download",
    "wide-groove": (p) => `A groove wider than ${p.mm} mm makes the layer that closes it print in mid air — the back may not come out smooth; try a smaller art size or flush 2-colour`,
  },
  dlstl: "STL",
  copied: "Copied",
  fatal: "Could not load the calculator — try refreshing the page",
  buildTimeout: "A build did not finish in 10 seconds and was restarted — try fewer characters or another font",

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  aboutH2: "How the personalised phone case works",
  aboutP1: "Pick the iPhone 16 Pro Max or iPhone 16 model, print a name or your logo SVG file, then download a 3MF or STL to print. The case prints back-side down with no supports; the rim rises slightly over the screen edge to hold the phone, with openings for the camera, the Camera Control button and the charge port.",
  aboutP2: "The flat style takes 2 colours with the art in a third colour level with the case — it needs a multi-colour printer; the engraved style prints in one. The SVG file stays on your device, is sent nowhere and never appears in the copied link.",
  aboutPrint: "The fit numbers (the gap around the phone, the rim depth) come from other designers' practice; nothing has been printed and fitted to a real phone. Passed simulation and slicing in OrcaSlicer only.",
  aboutTerms: "This tool is for learning and personal use. It is not endorsed by the phone maker; a printed case may not fit or protect. All risk is yours.",
  aboutTrademark: "iPhone is a trademark of Apple Inc. This tool is not made by or connected to Apple; model names appear only to say which device the case fits.",
};
export default S;
